import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import DatePicker from 'jsx/elements/inputs/DatePicker';
import Button from 'jsx/elements/buttons/Button';
import Checkbox from "jsx/elements/inputs/Checkbox";


class CalculateDatesBox extends React.Component {

  state = {
    calculateToDate : moment(),
    principalsTo : moment(),
    isBond : false,
    calledIn : false,
    calledInBecauseOfDefault : false
  };

  constructor(props){
    super(props);
    this.onCalculateClick = this.onCalculateClick.bind(this);
    this.onCalledInCheck = this.onCalledInCheck.bind(this);
    this.onCalledInBecauseOfDefaultCheck = this.onCalledInBecauseOfDefaultCheck.bind(this);
  }

  updateProps(props){
    if (props.data) {
      this.setState({
        calculateToDate : moment(props.data.calculateTo),
        principalsTo : moment(props.data.principalsTo),
        isBond : props.data.isBond}, ()=>{
        if (props.data.isBond){
          if (props.data.bond.legs[0].calledIn) {
            this.setState({
              calledIn: props.data.bond.legs[0].calledIn,
              calledInBecauseOfDefault: props.data.bond.legs[0].calledInBecauseOfDefault,
              principalsTo: moment(props.data.bond.legs[0].calledInDate)
            })
          }
        }
      });
    }
  }

  componentDidMount(){
    this.updateProps(this.props);
  }

  componentWillReceiveProps(nextProps){
    this.updateProps(nextProps);
  }

  onCalledInCheck(){
    this.setState({ calledIn: !this.state.calledIn },()=>{
      if (!this.state.calledIn){
        this.setState({ calledInBecauseOfDefault: false });
      }
    });

  };

  onCalledInBecauseOfDefaultCheck(){
    this.setState({ calledInBecauseOfDefault: !this.state.calledInBecauseOfDefault });
  };


  onCalculateClick(){
    if (this.props.onCalculate) {
      this.props.onCalculate(this.state.calculateToDate.toDate(), this.state.principalsTo.toDate(), this.state.calledIn, this.state.calledInBecauseOfDefault);
    }
  }

  onChange(name, value) {
    if (name === "calculateToDate"){
      // console.debug("change state", name, value);
      this.setState({ calculateToDate: value });
    }
    else if (name === "principalsTo")
    {
      //console.debug("change state", name, value);
      this.setState({ principalsTo: value });
    }

    if (this.props.onChangeDate){
      this.props.onChangeDate(name, value.toDate());
    }
  }

  render() {
    return (
      <div className="calc-dates-box calc-div-inline">
        <div className="calc-div-inline calc-div-inline-space">
        <span className="calc-text-space">
          Reikna til: &nbsp; <DatePicker value={this.state.calculateToDate} onChange={d => this.onChange('calculateToDate', d)}/>
        </span>
        </div>
        <div className="calc-div-inline calc-div-inline-space">
          <span className="calc-text-space">
            Höfuðstólar til: &nbsp; <DatePicker value={this.state.principalsTo} onChange={d => this.onChange('principalsTo', d)}/>
          </span>
        </div>
        {this.state.isBond && <div className="calc-div-inline calc-div-inline-space">
          <input id="checkCalledInCalculate" type="checkbox" checked={this.state.calledIn} onChange={this.onCalledInCheck} /> <label className="calc-small-checkbox-label calc-div-inline-space" htmlFor="checkCalledInCalculate" >Gjaldfellt</label>
          <input disabled={!this.state.calledIn} id="checkCalledInDefaultedCalculate" type="checkbox" checked={this.state.calledInBecauseOfDefault} onChange={this.onCalledInBecauseOfDefaultCheck}/> <label className="calc-small-checkbox-label calc-div-inline-space" htmlFor="checkCalledInDefaultedCalculate" >v/ vanskila</label>
        </div>}
        <Button className="fixButtonPadding" text="Reikna" onClick={this.onCalculateClick} />
      </div>
    );
  }
}

CalculateDatesBox.propTypes = {
  data: PropTypes.object,
  onCalculate : PropTypes.func,
  onChangeDate : PropTypes.func
};



export default CalculateDatesBox;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Boxes/CalculateDatesBox.js